module.exports = __webpack_public_path__ + "img/1501675753069.c648a715.jpg";